import ProductInfo from './ProductInfo.jsx';

export {
  ProductInfo
}


// WEBPACK FOOTER //
// ./components/product-detail/sub-view/product-info/index.js